define('lq/parameterShell',[
    'underscore',
    'globalize',
    'lq/constants',
    'lq/parameterCollection'
], function (_, globalize, constants, ParameterCollection) {
    
    var createSystemParameters = function (serverSystemParameters) {
        var systems = new ParameterCollection();

        _.each(_.keys(serverSystemParameters), function (serverSystemParameter) {
            systems.setValue(serverSystemParameter, serverSystemParameters[serverSystemParameter]);
        });

        systems.setValue('CurrentDate', function () {
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            return globalize.format(today, constants.licquidDateFormat);
        });

        systems.setValue('CurrentDateTime', function () {
            var now = new Date();
            return globalize.format(now, constants.licquidDateFormat);
        });

        systems.setValue('CurrentTime', function () {
            var now = new Date();
            return globalize.format(now, constants.licquidDateFormat);
        });

        systems.setValue('CurrentLayoutName', '');

        return systems;
    };

    var ParameterShell = function (localsCollection, globalsCollection, systemsCollection) {
        this.locals = localsCollection;
        this.globals = globalsCollection;
        this.systems = systemsCollection;
    };

    ParameterShell.createEmpty = function() {
        return new ParameterShell(
            new ParameterCollection(),
            new ParameterCollection(),
            new ParameterCollection()
        );
    };

    ParameterShell.createFrom = function (localParameters, globalParameters, serverSystemParameters) {
        return new ParameterShell(
            new ParameterCollection(localParameters),
            new ParameterCollection(globalParameters),
            createSystemParameters(serverSystemParameters)
        );
    };

    ParameterShell.prototype.getNonSystemParameters = function () {
        var all = {};

        // local parameters have higher priority so we overwrite any global parameter with the same name here
        this.globals.copyInto(all);
        this.locals.copyInto(all);

        return all;
    };

    ParameterShell.prototype.getAll = function () {
        var all = {};

        // on the server the system parameters have the highest priority
        // on the client they have the lowest priority (for now)
        // reason: some of these parameter names might actually already be in use
        // in some applications
        this.systems.copyInto(all);
        this.globals.copyInto(all);
        this.locals.copyInto(all);

        return all;
    };

    ParameterShell.prototype.getValue = function (key) {
        var local = this.locals.getValue(key);
        if (local !== undefined) return local;

        var global = this.globals.getValue(key);
        if (global !== undefined) return global;

        return this.systems.getValue(key);
    };

    //e.g. replaces token '{param0001}' with value of the parameter 'param0001'
    ParameterShell.prototype.replace = function (text) {
        if (!text) return text;

        var self = this;
        return text.replace(/\{(\w+)\}/g, function (match, paramName) {
            return self.getValue(paramName);
        });
    };

    ParameterShell.prototype.createChildScope = function (newLocals) {
        return new ParameterShell(
            this.locals.createChildScope(newLocals),
            this.globals.createChildScope(),
            this.systems
        );
    };

    return ParameterShell;
});
